module.exports = __webpack_public_path__ + "static/media/speed.e2d8e2b3.jpg";